import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "../../lib/api";

const STYLES = {
  submitted: "bg-amber-100 text-amber-800", under_review: "bg-blue-100 text-blue-800", approved: "bg-emerald-100 text-emerald-800",
  rejected: "bg-red-100 text-red-700", received: "bg-amber-100 text-amber-800", in_progress: "bg-blue-100 text-blue-800",
  resolved: "bg-emerald-100 text-emerald-800", closed: "bg-slate-200 text-slate-700",
};

export const StatusBadge = ({ status }) => (
  <span className={`inline-block rounded-full px-2.5 py-0.5 text-[11px] font-semibold capitalize ${STYLES[status] || "bg-slate-100"}`} data-testid="status-badge">{status?.replace("_", " ")}</span>
);

export const PrivateFile = ({ fileId, label, testId }) => {
  const [url, setUrl] = useState(null);
  const [type, setType] = useState("");
  useEffect(() => {
    let obj;
    api.get(`/admin/files/${fileId}`, { responseType: "blob" }).then((r) => {
      obj = URL.createObjectURL(r.data); setType(r.data.type); setUrl(obj);
    }).catch(() => setUrl("error"));
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [fileId]);
  return (
    <div className="rounded-lg border border-slate-200 p-3" data-testid={testId}>
      <p className="mb-2 text-xs font-semibold text-slate-500">{label}</p>
      {!url && <Loader2 className="h-5 w-5 animate-spin text-slate-400" />}
      {url === "error" && <p className="text-xs text-red-600">Could not load file</p>}
      {url && url !== "error" && (type.startsWith("image/")
        ? <a href={url} target="_blank" rel="noreferrer"><img src={url} alt={label} className="max-h-48 rounded object-contain" /></a>
        : <a href={url} target="_blank" rel="noreferrer" className="text-sm font-semibold text-royal underline">Open PDF</a>)}
    </div>
  );
};

export const Th = ({ children }) => <th className="px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wider text-slate-500">{children}</th>;
export const Td = ({ children, className = "" }) => <td className={`px-4 py-3 align-top text-sm text-slate-700 ${className}`}>{children}</td>;
